





import { DRAWING_STYLE } from "@/configs/drawing-style"
import { mapboxDrawControls, mapOptions, TOP_LEFT } from "@/configs/map-configs"
import DrawRestrictedRectangle, {
  DRAW_RESTRICTED_RECTANGLE
} from "@/utils/draw-restricted-rectangle-mode/draw-rectangle-mode"
import MapboxDraw from "@mapbox/mapbox-gl-draw"
import { GeolocateControl, Map, Marker, NavigationControl } from "mapbox-gl"
import { Component, Vue } from "vue-property-decorator"
import { Constants } from "../utils/draw-restricted-rectangle-mode/constants"

@Component({ name: "MapComponent" })
export default class MapComponent extends Vue {
  private map!: Map
  private mapboxDraw!: MapboxDraw
  private waterSourceMarker!: Marker

  constructor() {
    super()
  }

  private mounted() {
    this.map = new Map(mapOptions)

    this.addMapControl()
    this.handleMapEvents()
  }

  private addMapControl() {
    const geolocateControl = new GeolocateControl()
    const navigationControl = new NavigationControl()

    this.mapboxDraw = new MapboxDraw({
      displayControlsDefault: true,
      styles: DRAWING_STYLE,
      defaultMode: DRAW_RESTRICTED_RECTANGLE,
      // @ts-ignore
      modes: Object.assign(
        { draw_restricted_rectangle: DrawRestrictedRectangle },
        MapboxDraw.modes
      ),
      controls: mapboxDrawControls
    })
    this.map.addControl(geolocateControl, TOP_LEFT)
    this.map.addControl(navigationControl, TOP_LEFT)
    this.map.addControl(this.mapboxDraw as any, TOP_LEFT)
  }

  private handleMapEvents(): void {
    this.map.on(Constants.events.MODE_CHANGE, (event) => {
      if (event.mode === Constants.modes.DRAW_POLYGON) {
        // @ts-ignore
        this.mapboxDraw.changeMode(DRAW_RESTRICTED_RECTANGLE)
      }
    })

    this.map.on(Constants.events.CREATE, (event) => {
      if (event.features[0].geometry.type === Constants.geojsonTypes.POINT) {
        this.addWaterSourceMarker(event.features[0].geometry.coordinates)
      }
      if (event.features[0].geometry.type === Constants.geojsonTypes.POLYGON) {
        this.createArea(event)
      }
      if (
        event.features[0].geometry.type === Constants.geojsonTypes.LINE_STRING
      ) {
        this.$store.dispatch(Constants.events.MODE_CHANGE, event)
      }
    })

    this.map.on(Constants.events.DELETE, (event) => {
      if (event.features[0].geometry.type === Constants.geojsonTypes.POINT) {
        this.waterSourceMarker.remove()
      }
    })
  }

  private addWaterSourceMarker(lngLat: mapboxgl.LngLat): void {
    this.waterSourceMarker = new Marker({ draggable: true }).setLngLat(lngLat)
    this.waterSourceMarker.addTo(this.map)
    this.$store.dispatch(
      "commitWaterSource",
      this.waterSourceMarker.getLngLat()
    )
  }

  private createArea(event: Event | any): void {
    if (event.features[0]) {
      this.$store.dispatch("addToIrrigationArea", event.features[0])
      this.$store.state.isFormOpen = true
    }
  }
}
